import React from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { CodeRenderer, CustomTable } from "./MarkDownRenderers";
import rehypeSanitize from "rehype-sanitize";

const TextContent = ({ content }) => (
  <div>
    <Markdown
      children={content}
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeSanitize]}
      components={{
        code: CodeRenderer,
        table: CustomTable,
      }}
    />
  </div>
);

export default TextContent;
